// Role — four-tier model. platform_admin operates across tenants and has
// studioId === null. tenant_admin manages users + access tier within a single
// tenant. tenant_user calls MCP tools. contributor (S-722) has NO tenant
// membership either — studioId === null, same as platform_admin — but is
// scoped to their OWN marketplace listings via a separate contributorId,
// never to a tenant or platform/L1 resource. See AuthenticatedUser.ts's
// invariant and requireCapability.ts's ResourceScope for how the two
// null-studioId roles stay distinguished and isolated from each other.
import { z } from "zod";
export const RoleSchema = z.enum([
    "platform_admin",
    "tenant_admin",
    "tenant_user",
    "contributor",
]);
export const ROLES = RoleSchema.options;
//# sourceMappingURL=Role.js.map